// @flow
import styled from '@emotion/styled'
import * as React from 'react'

import { colors, media } from '@toggl/style'

import * as text from '../text'
import WorkflowCard from '../card/workflow'

type Props = {|
  +children: $ReadOnlyArray<React.Element<typeof WorkflowCard>>,
  +link: React.Node,
  +subtitle: React.Node | string,
  +title: React.Node | string,
|}

export default function Workflow({ children, subtitle, title, link }: Props) {
  return (
    <Wrapper>
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
      <Cards>{children}</Cards>
      <LinkWrapper>{link}</LinkWrapper>
    </Wrapper>
  )
}

const LinkWrapper = styled.div`
  a {
    margin: 40px auto 0;
    display: inline-block;
  }
`

const Wrapper: React.ComponentType<any> = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 30px;

  ${media.mq[1]} {
    a {
      margin-top: 40px;
    }
  }
  ${media.mq[2]} {
    a {
      margin-top: 60px;
    }
  }
`

const Title: React.ComponentType<any> = styled.div`
  ${text.heading2};
  color: ${colors.darkPurple};
  margin-bottom: 15px;
  ${media.mq[1]} {
    margin-bottom: 25px;
  }

  color: ${colors.darkPurple};
`

const Subtitle: React.ComponentType<any> = styled.div`
  ${text.paragraph2};
  color: ${colors.darkPurple};
  margin-bottom: 20px;

  ${media.mq[1]} {
    ${text.paragraph1};
    color: ${colors.darkPurple};
  }

  color: ${colors.fadedPurple};
`

const Cards: React.ComponentType<any> = styled.div`
  display: block;
  > div:not(:last-child) {
    margin-bottom: 60px;
  }

  ${media.mq[1]} {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    max-width: 1200px;
    margin: auto;
    > div:not(:last-child) {
      margin-bottom: 0;
    }
  }
`
